import Component from "vue-class-component";

// Register Vue Router navigation guards as class component hooks.
// This MUST be imported before any component that uses these hooks.
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
